module.exports = [{
      plugin: require('/Users/Scott.Arnold/Code/Client/Foundations/lauv-songs/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
